import teaTracker from './tea-tracker';

export enum LibraTestName {
  CAMPAIGN_REVAMP = 'mobile_campaign_revamp',
  PAYMENT_CHECK_V2 = 'payment_ready_v2',
  PAYNOW_API = 'paynow_update',
}

// immediate will be called in initAbVersionTea，asNeed need to use getAbVersionByName manually
enum LibraTestOccasion {
  asNeed,
  immediate,
}

export const LIBRA_TEST_CONFIG: Record<LibraTestName, LibraTestOccasion> = {
  // [LibraTestName.TestAbWebSdk]: LibraTestOccasion.immediate,
  [LibraTestName.CAMPAIGN_REVAMP]: LibraTestOccasion.immediate,
  [LibraTestName.PAYMENT_CHECK_V2]: LibraTestOccasion.immediate,
  [LibraTestName.PAYNOW_API]: LibraTestOccasion.immediate,
};

export enum LibraTestAbVersionResult {
  treatment = 'Treatment',
  control = 'Control',
}

interface LibraTestParamConfig {
  group?: LibraTestAbVersionResult;
}

/**
 *
 * @param name
 * @param defaultValue default value when api get nothing
 * @returns
 */
const getAbVersionTea = async (name: LibraTestName, defaultValue = {}) => {
  let abVersionResult = {};
  if (!name) {
    console.warn('getAbVersionTea: name is necessary');
    // 开发console.warn，线上上报
    return abVersionResult;
  }
  try {
    if (teaTracker && teaTracker.getAbVersion) {
      abVersionResult = await teaTracker.getAbVersion(name, defaultValue);
    }
    return abVersionResult;
  } catch (e) {
    return abVersionResult;
  }
};

/**
 * base on 'name' to see if hit the experiment
 * @param name
 */
export const getAbVersionByName = async (name: LibraTestName, defaultValue = {}) => {
  const abVersionResult: LibraTestParamConfig = await getAbVersionTea(name, defaultValue);
  return abVersionResult;
};
